import React, {ChangeEvent, memo, useCallback, useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from "common/hook";
import {loginActions} from "features/model/slice/lodinSlice";
import {getLoginState} from "features/model/selector/get-login-state/getLoginState";
import {loginByUsername} from "features/model/service/login-by-user-name/loginByUsername";
import {ReactComponent as OnlineClassIcon} from '../../assets/login/online-class.svg';
import {EyeOutlined, EyeInvisibleOutlined, LeftOutlined} from '@ant-design/icons';
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {Link} from 'react-router-dom';
import {LOGIN_TEXT} from "entities/constants/constants";

export const LoginForm = () => {
    const dispatch = useAppDispatch();

    const {email, password, isLoading, error} = useAppSelector(getLoginState);

    const [enterPressed, setEnterPressed] = useState(false);
    const [isPasswordVisible, setPasswordVisible] = useState(false);

    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false, false]);

    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.currentTarget;

        // Очистка ошибки при изменении соответствующего поля
        dispatch(loginActions.clearFieldError(name));

        if (name === 'email') {

            dispatch(loginActions.setUsername(value));
        } else if (name === 'password') {
            dispatch(loginActions.setPassword(value));
        }
    }, [dispatch]);

    const handleLogin = useCallback(async () => {
        await dispatch(loginByUsername({email, password}));
    }, [dispatch, email, password]);

    const handleKeyPress = useCallback((e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleLogin();
            setEnterPressed(true);
        }
    }, [handleLogin]);

    const togglePasswordVisibility = useCallback(() => {
        setPasswordVisible((prev) => !prev);
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);

    return (
        <div className="app service-page">
            <div className="bg-box">
                <OnlineClassIcon/>
            </div>

            <div className="form-box">
                <div className='btn-go-home'>
                    <a href="https://online-class.by/">
                        <LeftOutlined/>
                        На главную</a>
                </div>
                <div className='btn-go-home-mobile'>
                    <a href="https://online-class.by/">
                        <OnlineClassIcon/>
                    </a>
                </div>

                <div className="sub-box">

                    <p className="h3 popup-title">{LOGIN_TEXT}</p>
                    <form action="#" className={`form ${enterPressed ? 'enter-pressed' : ''}`}>
                        <div
                            className={`field required ${isFilled[0] ? 'filled' : ''} ${error && !error?.success ? 'error-field' : ''}`}>
                            <label className={`field-name ${email ? 'active-label' : ''}`}>Email</label>
                            <div className="inp-box">
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control"
                                    onChange={handleChange}
                                    value={email}
                                    onFocus={() => handleFocus(0)}
                                    onBlur={handleBlur}
                                />
                            </div>
                        </div>
                        <div
                            className={`field required ${isFilled[1] ? 'filled' : ''} ${error && !error?.success ? 'error-field' : ''}`}>
                            <label className={`field-name ${password ? 'active-label' : ''}`}>Пароль</label>
                            <div className="inp-box-password password-box">
                                <input
                                    type={isPasswordVisible ? "text" : "password"}
                                    name="password"
                                    className="form-control"
                                    onChange={handleChange}
                                    value={password}
                                    onFocus={() => handleFocus(1)}
                                    onBlur={handleBlur}
                                />
                                <button
                                    type="button"
                                    className="toggle-password-visibility"
                                    onClick={togglePasswordVisibility}
                                    aria-label="Toggle password visibility"
                                >
                                    {isPasswordVisible ? <EyeInvisibleOutlined/> : <EyeOutlined/>}
                                </button>
                            </div>
                            {error && !error?.success && <p className="field-error">{error.error}</p>}
                            <p className="field-propmt propmt_field">
                                <Link to="/restore-password">Забыли пароль?</Link>
                            </p>
                        </div>
                        <button disabled={isLoading} onClick={handleLogin} type="button" className="btn full-width">
                            <span>{isLoading ? <span className="loader"></span> : 'Войти'}</span>
                        </button>
                        <div className="form-prompt">
                            <p>
                                Нет учетной записи? <Link to="/register/">Зарегистрироваться</Link>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
